
export class DeletePropertyNoteRequest{
    public userId!:string;
    public businessId!:string;
    public propertyNoteId!:number;
}